import { AppService } from '../services'
import { AppState } from '../stores/app'
import { useEffect } from 'react'
import { IValueDidChange, observe } from 'mobx'
import { useService } from '@pushly/aqe/lib/hooks'
import { PlatformUserDomainRecord } from '../models/domain/platform-user-domain-record'

export const useActiveOrgChangeEffect = (onChange: (orgId: number, appSvc: AppService) => any) => {
    const appState = useService(AppState)
    const appSvc = useService(AppService)

    useEffect(() => {
        return observe(appState, 'currentDomainJsonData', (change: IValueDidChange<string>) => {
            const prev = PlatformUserDomainRecord.parseJsonObject(JSON.parse(change.oldValue ?? '{}'))
            const next = PlatformUserDomainRecord.parseJsonObject(JSON.parse(change.newValue ?? '{}'))

            if (!next || next.accountId === prev.accountId) return

            onChange(next.accountId, appSvc)
        })
    }, [])
}
